import React, { useEffect, useRef } from 'react';

interface VideoProps {
  isMobile: boolean;
}

const VIDEO_MOBILE = 'https://cdn.orqafpv.com/website/MFG_vertical.mp4';
const VIDEO_DESKTOP = 'https://cdn.orqafpv.com/website/MFG.mp4';

export const ScalableVideo = ({ isMobile }: VideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [isMobile]);

  return (
    <section className="newhomepage-scalable-section">
      <div className="newhomepage-scalable-content">
        <video
          ref={videoRef}
          className="newhomepage-scalable-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src={isMobile ? VIDEO_MOBILE : VIDEO_DESKTOP}
            type="video/mp4"
          />
        </video>

        <h2 className="newhomepage-scalable-subtitle">MANUFACTURING</h2>
        <div className="newhomepage-scalable-text">
          <h3 className="newhomepage-scalable-title">
            <span className="newhomepage-scalable-title-span">SCALABLE</span>
            <span className="newhomepage-scalable-title-span">
              SUPPLY CHAIN
            </span>
          </h3>
          <p className="newhomepage-scalable-description">
            Many drones rely on critical Chinese components, something that’s
            both a security risk and a potential barrier to scaling. Orqa is
            different. We manufacture every component we use, making our supply
            chain stable and secure.
          </p>
        </div>
      </div>
    </section>
  );
};
